/**
 * Unified Platform Theme Resolver.
 * Uses the Android Material Design 3 schema as the primary unified schema across all platforms.
 */

import { AndroidTheme } from "./android";
import { type IPlatformTheme } from "./types";

export * from "./types";
export * from "./base";
export * from "./components";
export { AndroidTheme } from "./android";

/**
 * Unified schema exports for web and iOS aliased to the primary Android schema.
 */
export const WebTheme: IPlatformTheme = { ...AndroidTheme, name: "web" };
export const IosTheme: IPlatformTheme = { ...AndroidTheme, name: "ios" };

/**
 * The resolved active platform theme based on runtime environment.
 * Unified across all platforms with Android Material Design 3 as the primary schema.
 */
export const CurrentPlatformTheme: IPlatformTheme = AndroidTheme;

/**
 * Canonical Colors object with light and dark mode palettes.
 * Sourced directly from the active unified platform theme.
 */
export const Colors = {
  light: CurrentPlatformTheme.light,
  dark: CurrentPlatformTheme.dark,
};
